import React from 'react';

function Divider() {
  return <div style={{ borderTop: '1px solid white', margin: '1em 0px' }} />;
}

export default Divider;
